


















































































import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import api from '@/api';
import { ApiResponse } from 'apisauce';
import ActivityIndicator from '@/components/ActivityIndicator.vue';
import { World } from '@/types';

@Component({
  components: { ActivityIndicator },
})
export default class Leaderboards extends Vue {
  @State public world!: World;

  public active = 'gold';
  public results = {
    data: [],
    loaded: -1,
  }

  public mounted() {
    this.setTab('gold');
  }
  public setTab(newTab: string) {
    this.active = newTab;
    this.results.data = [];
    this.results.loaded = 0;

    api.get(`/leaderboards/${newTab}`)
    .then((res: ApiResponse<any>) => {
      if (this.active !== newTab) {
      // the tab was changed while we loaded
        return;
      }

      if (res.ok) {
        const body = res.data;
        this.results.loaded = 1;
        this.results.data = body.data;
      } else {
        this.results.loaded = -1;
      }
    })
  }
}
